export default "__VITE_ASSET__nNdr8wWk__"